export enum OwnerOutreachStatus {
  PENDING = 'pending',
  CONTACTED = 'contacted',
  UNREACHABLE = 'unreachable',
  WILL_ATTEND = 'will_attend',
}

export const OWNER_OUTREACH_STATUSES = [
  OwnerOutreachStatus.PENDING,
  OwnerOutreachStatus.CONTACTED,
  OwnerOutreachStatus.UNREACHABLE,
  OwnerOutreachStatus.WILL_ATTEND,
] as const;

export interface OwnerOutreachRow {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  apartment?: string;
  phone?: string;
  coefficient: number;
  status: OwnerOutreachStatus;
  hasActiveDelegation: boolean;
  hasAcceptedDelegation: boolean;
  acceptedDelegationCoefficient: number;
  notes?: string | null;
  updatedAt?: string | null;
  outreachId?: string | null;
}

export interface OwnerOutreachSummary {
  totalOwners: number;
  pendingCount: number;
  contactedCount: number;
  unreachableCount: number;
  willAttendCount: number;
  delegatedCount: number;
  contactedThenDelegatedCount: number;
  needsContactCount: number;
  totalCoefficient: number;
  pendingCoefficient: number;
  contactedCoefficient: number;
  unreachableCoefficient: number;
  willAttendCoefficient: number;
  delegatedCoefficient: number;
  contactedThenDelegatedCoefficient: number;
  needsContactCoefficient: number;
  pendingContactPercent: number;
}

export interface OwnerOutreachListResponse {
  owners: OwnerOutreachRow[];
  summary: OwnerOutreachSummary;
  complexId: string;
  complexName: string;
}

export interface OwnerOutreachAssembliesResponse {
  complexes: Array<{ id: string; name: string }>;
  assemblies: Array<{
    id: string;
    title: string;
    scheduledDate?: string;
  }>;
  complexId: string | null;
  complexName: string | null;
}
